<template>
  <div>
    <template>
      <el-table
        :data="tableData"
        :fit="true"
        @selection-change="selectionChange"
        border
        class="multifunctional-table dic-sub-table-style01"
      >
        <el-table-column
          type="selection"
          :width="commonTableWidth.checkboxWidth"
          v-if="showCheckBox"
          align="center"
          header-align="center"
        />
        <el-table-column
          type="index"
          :width="commonTableWidth.serialNoWidth"
          label="序号"
          align="center"
          v-if="showIndex"
        >
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <template v-for="(table, index) in tableHead">
          <el-table-column
            :key="index"
            :label="table.label"
            :width="table.width"
            :min-width="table.width"
            :prop="table.prop"
            :align="table.align"
            :header-align="table.headerAlign"
            :show-overflow-tooltip="true"
            :formatter="table.formatter"
            v-if="!table.template"
          >
            <template slot-scope="scope">
              <el-button
                v-if="table.slot === 'opp'"
                type="text"
                @click="download(scope.$index, scope.row)"
                >下载</el-button
              >
              <!-- <el-button
                v-if="table.slot === 'opp'"
                type="text"
                @click="download(scope.$index, scope.row)"
                >预览</el-button
              > -->
              <slot
                v-else-if="table.slot"
                :row="scope.row"
                :$index="scope.$index"
                :name="table.slot"
              ></slot>
              <template v-else>
                <span
                  v-if="scope.row.required && scope.row.prop === table.prop"
                  style="color: #ff0000"
                  >*</span
                >
                {{ scope.row[table.prop] || "" }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </template>
  </div>
</template>

<script>
import { addUrlPerFix } from "@/basa/utils";
import { commonTableWidth } from "@/setting/setting";
export default {
  name: "detail-table",
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableHead: {
      type: Array,
      default: () => []
    },
    showCheckBox: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      commonTableWidth: commonTableWidth
    };
  },
  methods: {
    selectionChange(selection) {
      this.$emit("selectionChange", selection);
    },
    download(index, row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/sp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      console.log(openUrl.href);
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    }
  }
};
</script>

<style scoped></style>
